<div class="Customers overview-loyalty ui-g">

  <div class="ui-g-12 ui-lg-6">
    <h1 class="step-title">{{ 'store.analysis_title' | translate }}</h1>
  </div>
  <div class="ui-g-12 ui-lg-12">
    <p-steps [model]="items" [(activeIndex)]="activeIndex" [readonly]="false"></p-steps>

    <div class="ui-g-12">
      <kv-search-toolbar
        [dateBoxEnabled]="true"
        [date_structure]="searchModel.date_structure"
        [card_modes]="searchModel.card_modes"
        [clusters]="searchModel.cluster_list"
        [customersBoxEnabled]="false"
        [clusterFieldEnabled]="false"
        [selectedElapsedStart]="searchModel.selectedStartDate"
        [selectedElapsedEnd]="searchModel.selectedEndDate"
        [group_types]="searchModel.group_types"
        [groups]="searchModel.groups"
        [areas]="searchModel.areas"
        [stores]="searchModel.stores"
        [storeSelectionMode]="'single'"
        [disableMutualExclusivity]="false"
        [groupTypesFieldEnabled]="false"
        [groupFieldEnabled]="false"
        [areaFieldEnabled]="false"
        appQFilter
        (onQFilter)="performFilter($event)" #toolbar
      ></kv-search-toolbar>
    </div>

    <div class="overview-container card ui-g-nopad">
      <app-analysis-single-store-overview [hidden]="activeIndex !== 0"></app-analysis-single-store-overview>
    </div>

    <div class="overview-container card ui-g-nopad">
      <app-analysis-single-store-revenue [hidden]="activeIndex !== 1" ></app-analysis-single-store-revenue>
    </div>

    <div class="overview-container card ui-g-nopad">
      <app-analysis-single-store-trend [hidden]="activeIndex !== 2" ></app-analysis-single-store-trend>
    </div>

    <div class="overview-container card ui-g-nopad">
      <app-analysis-single-store-distribution [hidden]="activeIndex !== 3"></app-analysis-single-store-distribution>
    </div>

    <div class="overview-container card ui-g-nopad">
      <app-analysis-promo [hidden]="activeIndex !== 4"></app-analysis-promo>
    </div>

  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/store/analysis/analysis.component.html